import { render } from "./App.vue?vue&type=template&id=70fe736a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=70fe736a&lang=css"

import exportComponent from "/Users/jakubluszczek/Documents/Projekty/honesty-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__